// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lunch_underlined {
    width: 100%;
    border-bottom: 1px solid rgba(159, 172, 199, 0.4);
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.plans_form_title {
    font-size: 1rem;
    font-weight: 700;
    color: rgba(0,0,0,0.8);
}

.lunch_underlined > div > p {
    margin-top: 1rem;
    font-weight: 500;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    max-width: 600px;
    line-height: 1.5rem;
}

.plan_name {
    font-size: 12px;
    font-weight: 600;
    margin-right: 5px;
}

@media (max-width: 600px) {
    .lunch_underlined > div > p {
        font-size: 11px;
    }
}

.plans_form_line {
    margin-left: 20px;
    width: 100%;
    height: 1px;
    background-color: rgba(159, 172, 199, 0.4);
}

.lunch_form_row {
    display: flex;
    align-items: center;
    width: 100%;
    min-width: 265px;
}
.small {
    min-width: 100px;
    max-width: 190px;
}
@media (max-width:450px){
    .small {
        min-width: 100px;
        max-width: 400px;
    }
}
.lunch_form_dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #4B4B4B;
    margin-right: 24px;
}
.lunch_form_text {
    font-size: 16px;
    color: rgba(0,0,0,0.8);
    margin-bottom: 0;
    margin-right: 24px;
    min-width: 150px;
}
.lunch_form_select_box {
    width: 100%;
    height: 50px;
    max-width: 350px;
}
.lunch_form_input {
    -webkit-appearance: none;
    width: 100%;
    max-width: 176px;
    height: 50px;
    border-radius: 5px;
    border: 1px solid #CDE1EB;
    padding-left: 10px;
    font-size: 16px;
}


.chosen_date_block {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 1500px) {
    .chosen_date_block {
        grid-template-columns: 1fr 1fr 1fr;
    }
}

@media (max-width: 1000px) {
    .chosen_date_block {
        grid-template-columns: 1fr 1fr;
    }
}
@media (max-width: 600px) {
    .chosen_date_block {
        grid-template-columns: 1fr;
    }
}

.plans_list_wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
}
.edit_btn_text {
    padding-left: 7px;
    font-size: 14px;
    font-weight: 600;
    color: #767493;
}

.plans_item_box {
    display: flex;
    align-items: center;
    max-width: 60vw;
    overflow-x: auto;
}


.plan_delete_button {
    min-width: 40px;
    min-height: 40px;
    width: 40px;
    height: 40px;
    border-radius: 7px;
    border: 1px solid rgba(118, 116, 147, 0.34);
    background-color: #9FACC7;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 15px;
    margin-top: 6px;
    cursor: pointer;
}

.plans_item_container {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}

.selected_dates_container {
    margin-right: 10px;
    height: 40px;
    min-width: 120px;
    border: 1px solid rgba(14, 10, 64, 0.15);
    margin-top: 17px;
    border-radius: 5px;
    padding: 3px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 2px;
    box-sizing: border-box;
}

.selected_date_box {
    width: 100%;
    background-color: rgba(14, 10, 64, 0.15);
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-weight: 600;
}

.selected_date_box.unselected {
    opacity: 0.3;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Containers/LunchForm.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iDAAiD;IACjD,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;AACA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uCAAuC;AAC3C;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;IAC3C,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sCAAsC;IACtC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".lunch_underlined {\n    width: 100%;\n    border-bottom: 1px solid rgba(159, 172, 199, 0.4);\n    padding-bottom: 10px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.plans_form_title {\n    font-size: 1rem;\n    font-weight: 700;\n    color: rgba(0,0,0,0.8);\n}\n\n.lunch_underlined > div > p {\n    margin-top: 1rem;\n    font-weight: 500;\n    font-size: 14px;\n    color: rgba(0, 0, 0, 0.5);\n    max-width: 600px;\n    line-height: 1.5rem;\n}\n\n.plan_name {\n    font-size: 12px;\n    font-weight: 600;\n    margin-right: 5px;\n}\n\n@media (max-width: 600px) {\n    .lunch_underlined > div > p {\n        font-size: 11px;\n    }\n}\n\n.plans_form_line {\n    margin-left: 20px;\n    width: 100%;\n    height: 1px;\n    background-color: rgba(159, 172, 199, 0.4);\n}\n\n.lunch_form_row {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    min-width: 265px;\n}\n.small {\n    min-width: 100px;\n    max-width: 190px;\n}\n@media (max-width:450px){\n    .small {\n        min-width: 100px;\n        max-width: 400px;\n    }\n}\n.lunch_form_dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background-color: #4B4B4B;\n    margin-right: 24px;\n}\n.lunch_form_text {\n    font-size: 16px;\n    color: rgba(0,0,0,0.8);\n    margin-bottom: 0;\n    margin-right: 24px;\n    min-width: 150px;\n}\n.lunch_form_select_box {\n    width: 100%;\n    height: 50px;\n    max-width: 350px;\n}\n.lunch_form_input {\n    -webkit-appearance: none;\n    width: 100%;\n    max-width: 176px;\n    height: 50px;\n    border-radius: 5px;\n    border: 1px solid #CDE1EB;\n    padding-left: 10px;\n    font-size: 16px;\n}\n\n\n.chosen_date_block {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n}\n\n@media (max-width: 1500px) {\n    .chosen_date_block {\n        grid-template-columns: 1fr 1fr 1fr;\n    }\n}\n\n@media (max-width: 1000px) {\n    .chosen_date_block {\n        grid-template-columns: 1fr 1fr;\n    }\n}\n@media (max-width: 600px) {\n    .chosen_date_block {\n        grid-template-columns: 1fr;\n    }\n}\n\n.plans_list_wrapper {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255,255,255,0.8);\n}\n.edit_btn_text {\n    padding-left: 7px;\n    font-size: 14px;\n    font-weight: 600;\n    color: #767493;\n}\n\n.plans_item_box {\n    display: flex;\n    align-items: center;\n    max-width: 60vw;\n    overflow-x: auto;\n}\n\n\n.plan_delete_button {\n    min-width: 40px;\n    min-height: 40px;\n    width: 40px;\n    height: 40px;\n    border-radius: 7px;\n    border: 1px solid rgba(118, 116, 147, 0.34);\n    background-color: #9FACC7;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-left: 15px;\n    margin-top: 6px;\n    cursor: pointer;\n}\n\n.plans_item_container {\n    width: 100%;\n    max-width: 100%;\n    box-sizing: border-box;\n}\n\n.selected_dates_container {\n    margin-right: 10px;\n    height: 40px;\n    min-width: 120px;\n    border: 1px solid rgba(14, 10, 64, 0.15);\n    margin-top: 17px;\n    border-radius: 5px;\n    padding: 3px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    grid-gap: 2px;\n    box-sizing: border-box;\n}\n\n.selected_date_box {\n    width: 100%;\n    background-color: rgba(14, 10, 64, 0.15);\n    font-size: 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 3px;\n    font-weight: 600;\n}\n\n.selected_date_box.unselected {\n    opacity: 0.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
